<template>
  <div>
    <div class="row p-2">
      <div class="col text-right">
        <button v-if="!show.documentosObrigatorios && !show.modal"
                class="btn btn-primary btn-sm addDocs"
                @click="show.modal = true, $emit('onShowLista', false)">
          <icon-svg class="icons--white icon--xxs"
                    icon="add" />
          Adicionar
        </button>
      </div>
    </div>

    <div v-if="show.documentosObrigatorios"
         class="row AdicionarImagem p-2">
      <div class="col">
        <documentos-obrigatorios :prop-documents="propDocumentos"
                                 :prop-tipo-documento="propTipoDocumento"
                                 @onAdd="addDocumentos" />
      </div>
    </div>

    <div v-if="show.modal">
      <div class="AdicionarImagem--border">
        <collapse-default v-if="!propHabilitacao.gerar_autuacao"
                          id="documentos"
                          :style-default="false"
                          header-class="AdicionarImagem--header p-1 icons--white"
                          icons-class="icons--white icon--xxs"
                          :collapse-visible="documents.filter(document => document.url_s3 != null) == 0"
                          :icons-show="true">
          <template v-slot:header>
            Documentos
          </template>

          <template v-slot:content>
            <documentos-obrigatorios :prop-documents="propDocumentos"
                                     :prop-tipo-documento="propTipoDocumento"
                                     @onAdd="addDocumentos"
                                     @onShowDocumentosObrigatorios="showDocumentosObrigatorios" />
          </template>
        </collapse-default>


        <hr class="m-0">

        <form-documentos @onAdd="adicionarDoc" />
      </div>

      <div slot="modal-footer">
        <div class="row">
          <div class="col text-right mt-2 mb-5">
            <button class="btn AdicionarImagem--btn-default btn-sm"
                    @click="hiddenModal">
              Voltar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  /* components */
  import DocumentosObrigatorios
    from "@/components/SofiaRei/HabilitacaoCasamento/PrepararProcesso/DocumentosObrigatorios"
  import FormDocumentos
    from "@/components/SofiaRei/HabilitacaoCasamento/PrepararProcesso/FormDocumentos"
  import CollapseDefault from "@/components/SofiaRei/Resumo/Collapses/CollapseDefault"

  /* constants */
  import { EDITAL_OUTRA_SERVENTIA } from "@/constants/casamento/tipos"

  export default {
    name: "AdicionarImagem",
    components: {
      FormDocumentos,
      DocumentosObrigatorios,
      CollapseDefault
    },
    props: {
      propHabilitacao: {
        type: Object,
        default: () => ({})
      },
      propDocumentos: {
        type: Array,
        default: () => []
      },
      propTipoDocumento: {
        type: String,
        default: () => null
      },
      propTab: {
        type: Number,
        default: () => 0
      }
    },
    data () {
      return  {
        EDITAL_OUTRA_SERVENTIA,
        show: {
          documentosObrigatorios: true,
          modal: false
        },
        documents: []
      }
    },
    watch: {
      'propDocumentos.length' () {
        this.init()
      },
      propTab () {
        if (this.propTab == 4) {
          this.verifyFocus()
        }
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        const docsObrigatorios = this.propDocumentos.filter(doc => doc.obrigatorio == true)
        if (docsObrigatorios.length > 0) {
          this.show.documentosObrigatorios = false
        } else {
          this.show.documentosObrigatorios = true
        }

        if (this.propTipoDocumento === this.EDITAL_OUTRA_SERVENTIA && this.propDocumentos.length > 0) {
          this.show.documentosObrigatorios = false
        }

        if (this.propHabilitacao.gerar_autuacao) {
          this.show.documentosObrigatorios = false
          this.show.modal = true
          this.$emit('onShowLista', false)
        }

        if (['resumo_habilitacao_casamento', 'editar_habilitacao_casamento'].indexOf(this.$route.name) != -1) {
          this.show.documentosObrigatorios = false
          this.show.modal = false
          this.$emit('onShowLista', true)
        }


        this.documents = [ ...this.propDocumentos ]
        this.verifyFocus()
      },
      cancel () {
        this.$emit('onCancel')
      },

      adicionarDoc (doc) {
        this.documents.push(doc)
        this.$emit('onNewImage', this.documents)
        this.show.modal = false
        this.$emit('onShowLista', true)
      },

      addDocumentos (docs) {
        this.documents = docs

        this.$emit('onNewImage', this.documents)

        if (this.propTipoDocumento === this.EDITAL_OUTRA_SERVENTIA && this.documents.length > 0) {
          this.show.documentosObrigatorios = false
        }

        this.show.modal = false
        this.$emit('onShowLista', true)
      },

      showDocumentosObrigatorios (value) {
        this.show.documentosObrigatorios = value
      },

      hiddenModal () {
        // this.$refs['modal-adicionar-imagem'].hide()

        this.show.modal = false
        this.$emit('onShowLista', true)
        this.verifyFocus()
        /*setTimeout(() => {
          this.show.modal = false
        }, 200)
        setTimeout(() => {
          this.show.modal = true
        }, 300)*/
      },
      verifyFocus () {
        if (!this.show.documentosObrigatorios && !this.show.modal) {
          setTimeout(() => {
            const btnAdicionar = document.querySelector('.addDocs')
            btnAdicionar.focus()
          }, 100)
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../../scss/_utilities/exports";

 .AdicionarImagem {
   &--border {
     border: 1px $color-black;
     border-style: dashed;
   }

   &--header{
     background-color: black;
     color: $color-white;
   }

   &--btn-default {
     background-color: #C6C6C6
   }
 }

  .label{
    font-size: 14px !important;
  }
</style>
